import _ from 'lodash'
import template from '../wizard/common/select-scorecard-dialog.hbs'
import SelectScorecardView from '../wizard/common/select-ancestor-scorecard-step'

var ScorecardStructureScorecardDialog = SelectScorecardView.extend({

	events: _.assign({}, SelectScorecardView.prototype.events, {
		'submit': 'submit'
	}),

	initialize: function() {
		SelectScorecardView.prototype.initialize.apply(this, arguments)
		this.listenTo(this.model, 'change', () => {
			this.$('.button-primary').attr('disabled', !this.model.isValid())
		})
	},

	_template: function() {
		return template()
	},

	submit: function(e) {
		e.preventDefault()
		this.trigger('done', this.model)
	}

})

export default ScorecardStructureScorecardDialog

ScorecardStructureScorecardDialog.__filename__ = 'reports/scorecard-structure/scorecard-structure-scorecard-dialog.js'
